import type { FilterMode } from "@/components/filters/Condition/types";
import { FILTER_MODE } from "@/components/filters/Condition/constants";

export type ProductsSlice = {
  sections: Array<{
    inclusionMethod: FilterMode;
    productIds: number[];
    departmentIds: string[];
    roleIds: string[];
    installAgeMonths?: { min?: number; max?: number };
    intensity?: { min?: number; max?: number };
  }>;
  excludedProductIds: number[];
};

export const defaultProductsSlice: ProductsSlice = {
  sections: [
    {
      inclusionMethod: FILTER_MODE.ANY,
      productIds: [],
      departmentIds: [],
      roleIds: [],
      installAgeMonths: undefined,
      intensity: undefined,
    },
  ],
  excludedProductIds: [],
};
